/**
 * HSPG cart upsell — swaps the single guide(s) in the cart for the 5-guide bundle.
 *
 * Bindings are DELEGATED at the document level. The cart drawer replaces its own
 * markup wholesale (CartDrawer.renderContents() → sectionElement.innerHTML = …)
 * on every cart change, which silently drops any listener attached straight to
 * the button. Delegation keeps the upgrade and dismiss controls alive across
 * those swaps and across `shopify:section:load` in the theme editor.
 *
 * After a successful upgrade we re-render the drawer from the sections returned
 * by /cart/add.js (the Dawn pattern) when the button lives inside the drawer —
 * no full page reload, drawer stays open. Outside the drawer (the /cart page,
 * where the line items and totals are server-rendered by other sections) we fall
 * back to a reload, which is the robust option there.
 */
(function () {
  var UPGRADE_SELECTOR = '[data-hspg-upgrade-bundle]';
  var DISMISS_SELECTOR = '[data-hspg-dismiss-upsell]';
  var UPSELL_SELECTOR = '[data-hspg-cart-upsell]';

  function route(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || (data && data.status && data.status >= 400)) {
          throw new Error((data && (data.description || data.message)) || 'Cart request failed');
        }
        return data;
      });
    });
  }

  /** The drawer instance this button lives in, or null when it is elsewhere. */
  function drawerFor(button) {
    var drawer = button.closest ? button.closest('cart-drawer') : null;
    return drawer && typeof drawer.renderContents === 'function' ? drawer : null;
  }

  function upgrade(button) {
    if (button.disabled) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var removeKeys = (button.getAttribute('data-remove-keys') || '').split(',').filter(Boolean);
    var drawer = drawerFor(button);
    var label = button.textContent;

    button.disabled = true;
    button.textContent = 'Upgrading…';

    var chain = Promise.resolve();

    removeKeys.forEach(function (key) {
      chain = chain.then(function () {
        return postJSON(route('cart_change_url', '/cart/change'), { id: key, quantity: 0 });
      });
    });

    chain
      .then(function () {
        var body = { items: [{ id: variantId, quantity: 1 }] };
        if (drawer) {
          body.sections = drawer
            .getSectionsToRender()
            .map(function (section) {
              return section.id;
            })
            .join(',');
          body.sections_url = window.location.pathname;
          drawer.setActiveElement(button);
        }
        return postJSON(route('cart_add_url', '/cart/add'), body);
      })
      .then(function (data) {
        if (drawer && data && data.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
          return;
        }
        window.location.reload();
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = label;
      });
  }

  function dismiss(button) {
    var card = button.closest ? button.closest(UPSELL_SELECTOR) : null;
    if (card) card.remove();
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var upgradeButton = target.closest(UPGRADE_SELECTOR);
    if (upgradeButton) {
      event.preventDefault();
      upgrade(upgradeButton);
      return;
    }

    var dismissButton = target.closest(DISMISS_SELECTOR);
    if (dismissButton) {
      event.preventDefault();
      dismiss(dismissButton);
    }
  });
})();
